<template>
  <v-app>
    <v-app-bar 
    app 
    absolute 
    color="white" 
    elevate-on-scroll 
    scroll-target="#scrolling-techniques-7"
    >
      <v-img
        alt="Mericsson Logo"
        class="shrink mr-2"
        contain
        src="./assets/avatar_face.png"
        transition="scale-transition"
        width="20"
      />
      <v-toolbar-title>MEE</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn href target="_blank" text>
        <span class="mr-2"></span>
        <v-icon></v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <HelloWorld />
    </v-main>
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>
